import { Component, Input } from '@angular/core'

@Component({
  selector: 'money-market-characteristic-results',
  templateUrl: './money-market-characteristic-results.component.html',
  styleUrls: ['./money-market-characteristic-results.component.scss'],
})
export class MoneyMarketCharacteristicResultsComponent {
  @Input() weightedAverageMaturity: string
  @Input() weightedAverageLife: string
}
